var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 4"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"MOBILE","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"1.5.2.1-Storage-Details","transform":"translate(-219.000000, -86.000000)","fill":"#4F4F4F","fillRule":"nonzero"},React.createElement("g",{"id":"Group-4","transform":"translate(220.000000, 87.000000)"},[React.createElement("polygon",{"id":"Line-3","points":"0.85 17.5 0.85 16.5 15.15 16.5 15.15 17.5","key":0}),React.createElement("polygon",{"id":"Line-2","points":"10.6682608 3.27720196 11.397798 2.59326083 14.3317392 5.72279804 13.602202 6.40673917","key":1}),React.createElement("path",{"d":"M14.3915165,0.693390877 L0.5,11.5126301 L0.5,13.5 L2.72261677,13.5 L16.2864601,2.99342288 L14.3915165,0.693390877 Z M17.7135399,3.15291858 L3.06461727,14.5 L-0.5,14.5 L-0.5,11.0239553 L14.5446537,-0.693390877 L17.7135399,3.15291858 Z","id":"Line-2-Copy-2","key":2})])))]);
}

Edit.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = Edit;

Edit.default = Edit;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/edit.svg
// module id = 1480
// module chunks = 0